<template>
<div class="navigator">
	<div class="dot" :class="{selected: slide === 0}" />
	<div class="devider" :style="devider1" />
	<div class="dot" :class="{selected: slide === 1}" />
	<div class="devider" :style="devider2" />
	<div class="dot" :class="{selected: slide === 2}" />
</div>
</template>


<script>

export default {
	name: 'Shares',
	props: {
		slide: Number,
	},
	data() {
		return {
			opened: false,
		}
	},
	computed: {
		devider1() {
			if (this.slide < 2) return { flex: 1 }
		},
		devider2() {
			if (this.slide > 0) return { flex: 1 }
		},
	},
	methods: {
		
	},
}
</script>


<style lang="less" scoped>
@import '../assets/app.less';

.navigator {
	width: 10px;
	height: 120px;
	position: fixed;
	right: 20px;
	top: 50%;
	transform: translateY(-50%);
	display: flex;
	justify-content: space-between;
	flex-direction: column;
	align-items: center;
}

.dot {
	width: 11px;
	height: 11px;
	box-sizing: border-box;
	border: 1px solid @gold;
	background: @gold;
	border-radius: 5px;
	flex-shrink: 0;
	transition: all 500ms ease;

	&.selected {
		background: transparent;
	}
}

.devider {
	width: 1px;
	flex: 0;
	margin: 5px 0;
	background: @gold;
	transition: all 500ms ease;
}



@media only screen and (max-width: 1000px) {

.navigator {
	display: none;
}

}


</style>
